import { WEB_API_BASE_PATH } from "common/constants";

export interface ShowroomPublicPlanUrlParams {
  builderId: string;
  planType: "community_plans" | "master_plans";
  planId: string;
  lotId?: string;
}

export function buildShowroomPublicPlansUrl({
  builderId,
  planType,
  planId,
  lotId,
}: ShowroomPublicPlanUrlParams): string {
  const lotSuffix = lotId ? `&lotId=${lotId}` : "";
  return `${WEB_API_BASE_PATH}/builders/${builderId}/public-plans?planType=${planType}&planId=${planId}${lotSuffix}`;
}
